module.exports = __webpack_public_path__ + "img/bedOrange.65a13d87.png";